import { css } from 'lit';

export const style = css`
  .personal__first-name,
  .personal__last-name {
    margin: 0.5em 0;
  }

  .iconic-v2 {
    margin-top: auto;
  }

  @media (width >= 542px) {
    .personal__compact-name {
      display: grid;
      gap: 1rem;
      grid-template-columns: 1fr 1fr;
    }

    .personal__compact-name > .personal__first-name {
      margin-bottom: -1rem;
    }

    .personal__compact-name > .personal__last-name {
      margin-bottom: -1rem;
    }
  }
`;
